import { getReferenceRoomUrl } from '@/service/dashboard/getReferenceRoomUrl';

/**
 * ヘッダ
 * @param {*} $scope
 * @param {*} $http
 * @param {*} serverService
 * @param {*} $modal
 * @param {*} $state
 * @param {*} $interval
 * @param {*} Push
 * @param {*} $cookies
 * @param {*} $window
 * @param {*} $sce
 * @param {*} $timeout
 * @param {*} agenciesService
 * @param {*} facilityService
 */
function headerCtrl(
  $scope,
  $http,
  serverService,
  $modal,
  $state,
  $interval,
  Push,
  $cookies,
  $window,
  $sce,
  $timeout,
  agenciesService,
  facilityService
) {
  // サービス切り替え時の処理
  $scope.$on('serviceChanged', function (event, data) {
    $scope.initial();
  });

  $scope.initial = () => {
    // 自身の設定を取得
    $scope.getMine().then(function () {
      // サービス設定を取得
      var service_id = $scope.my.current_service_id ? $scope.my.current_service_id : $scope.my.service_id;
      $scope.getService(service_id).then(function () {
        $scope.logoImageFileName = getLogoImageFileName();
        // 連絡受付機能を使用する
        if (
          $scope.services &&
          $scope.services.attributes &&
          $scope.services.attributes.contact_use == $scope.system.FLAG_ON.toString()
        ) {
          Push.Permission.request(
            function () {
              // eslint-disable-next-line
              if (!$scope.getSize(globalNotifyTimer)) {
                // 初回のデータを取得
                if ($scope.getDevice() == $scope.system.DEVICE_TYPE_OHTER) {
                  $scope.checkNotifications();

                  // 定期処理を設定
                  // eslint-disable-next-line
                  globalNotifyTimer = $interval(function () {
                    $scope.checkNotifications();
                  }, 1000 * 60 * 2);
                }
              }
            },
            function () {
              $scope.cancelNotifyTimer();
            }
          );
        } else {
          $scope.cancelNotifyTimer();
        }

        // チュートリアル
        $scope.setTutorial(false);

        $scope.setScopeBillsForCheck().then(function () {
          $scope.hasAuthForInquiryFee();

          // 「プランとお支払い」の通知表示
          $scope.notifyLatestBill();
        });

        $scope.isDirectContractFacilities = agenciesService.containsDirectContractFacilities(
          $scope.my.manage_service?.id
        );
      });
    });
  };

  $scope.cacheClear = function () {
    var title = '確認';
    var message =
      'この端末に保存されているキャッシュデータを削除します。実際に入力されているデータに影響はありません。よろしいですか？';
    var callback = function () {
      try {
        // cookieの削除
        if (document.cookie) {
          angular.forEach($cookies.getAll(), function (value, key) {
            console.log(key + ':' + value);
            if (key != '_ga' && key != '_gid' && key != 'PHPSESSID') {
              $cookies.remove(key);
            }
          });
        }

        // ローカルストレージのクリア
        if (window.localStorage) {
          window.localStorage.clear();
        }
      } catch (e) {}
      serverService.message('キャッシュをクリアしました');
    };
    serverService.confirm($scope, $modal, title, message, callback);
  };

  // チュートリアルの初期処理
  $scope.setTutorial = function (shouldExpand) {
    // 設定もしくは園児台帳の権限をもっている場合に表示
    if ($scope.checkAuthority('setting')) {
      if ($scope.services.attributes && $scope.services.attributes.tutorial_onboarding) {
        $scope.tutorial = angular.fromJson($scope.services.attributes.tutorial_onboarding);

        if ($scope.tutorial.on) {
          if (shouldExpand) {
            $scope.tutorial.tutorial_expand = true;
          } else {
            $scope.tutorial.tutorial_expand = false;
          }

          $scope.tutorial.never_view_flag = false;

          $scope.checkTutorialStepComplete();
          $scope.showTutorialText($state.current);
        }
      } else {
        $scope.tutorial = {};
        $scope.tutorial.on = false;
      }
    } else {
      $scope.tutorial = {};
      $scope.tutorial.on = false;
    }
  };

  // チュートリアルの開閉
  $scope.toggleTutorialExpand = function (flag) {
    if (angular.isDefined(flag)) {
      $scope.tutorial.tutorial_expand = flag;
    } else {
      $scope.tutorial.tutorial_expand = !$scope.tutorial.tutorial_expand;
    }
  };

  // チュートリアルを閉じる
  $scope.hideTutorialText = function () {
    $scope.tutorial.show_tutorial_text = false;
  };

  // チュートリアルの説明を表示
  $scope.showTutorialText = function (toState) {
    if (!$scope.tutorial.on) {
      return;
    }

    var state_name = '';
    var show_tutorial_text = false;
    var tutorial_title = '';
    var tutorial_description = '';
    var manual_link = '';
    if (toState) {
      state_name = toState.name;
    } else {
      return;
    }

    angular.forEach($scope.tutorial.steps, function (step, index) {
      if (state_name === $scope.system.array_tutorial_step_state_name[$scope.tutorial.type][index]) {
        show_tutorial_text = true;
        tutorial_title = $scope.system.array_tutorial_step_title[$scope.tutorial.type][index];
        tutorial_description = $scope.system.array_tutorial_step_description[$scope.tutorial.type][index];
        manual_link = $scope.system.array_tutorial_step_manial_link[$scope.tutorial.type][index];
      }
    });
    $scope.tutorial.tutorial_title = tutorial_title;
    $scope.tutorial.tutorial_description = $sce.trustAsHtml(tutorial_description);
    $scope.tutorial.show_tutorial_text = show_tutorial_text;
    $scope.tutorial.manual_link = manual_link;
  };

  // チュートリアルのステップを完了
  $scope.completeTutorialStep = function (step, index, is_advance, is_toggle) {
    if (!step.complete) {
      step.complete = true;
      if (angular.isUndefined(step.complete_count)) {
        step.complete_count = 0;
      }
      step.complete_count++;
    } else {
      if (is_toggle) {
        step.complete = false;
      }
    }

    step.complete_administrator_id = $scope.my.id;
    step.complete_datetime = $scope.getFormattedDatetime();
    $scope.checkTutorialStepComplete();
    $scope.updateTutorial();
    if (step.complete) {
      if (is_advance) {
        // do nothing now
      } else {
        serverService.message($scope.system.array_tutorial_step_complete_message[$scope.tutorial.type][index]);
      }
    }
  };

  // チュートリアルの完了数をカウント
  $scope.checkTutorialStepComplete = function () {
    var count = 0;
    angular.forEach($scope.tutorial.steps, function (step) {
      if (step.complete) {
        count++;
      }
    });
    $scope.tutorial.complete_count = count;
  };

  // 今後表示しないフラグの変更
  $scope.changeNeverViewFlag = function () {
    if ($scope.tutorial.never_view_flag) {
      // 一旦OFFにする
      $scope.tutorial.never_view_flag = false;
      var title = '確認';
      var message =
        '<strong>次回画面遷移後よりこのチュートリアルが表示されなくなります</strong>。よろしいですか？<br>再度表示させたい場合には画面右上の「ヘルプ」メニュー内の「チュートリアル」より最初から再スタートできます。';
      var callback = function () {
        // 確認OKであれば改めてONにする
        $scope.tutorial.never_view_flag = true;
        delete $scope.tutorial.tutorial_title;
        delete $scope.tutorial.tutorial_description;
        delete $scope.tutorial.show_tutorial_text;
        delete $scope.tutorial.manual_link;
        $scope.updateTutorial();
      };
      serverService.confirm($scope, $modal, title, message, callback);
    } else {
      $scope.updateTutorial();
    }
  };

  // チュートリアル状態を保存
  $scope.updateTutorial = function () {
    $scope.tutorial.update_administrator_id = $scope.my.id;
    $scope.tutorial.update_datetime = $scope.getFormattedDatetime();

    var params = {};
    params['mode'] = 'update_tutorial_attributes_' + $scope.tutorial.type;
    var obj = angular.copy($scope.tutorial);
    if ($scope.tutorial.never_view_flag) {
      obj.on = false;
    }
    params['attributes.tutorial_' + $scope.tutorial.type] = angular.toJson(obj);

    var service_id = $scope.my.current_service_id ? $scope.my.current_service_id : $scope.my.service_id;

    console.log(params);

    $http
      .put(serverService.apiEndPoint + 'services/' + service_id, params)
      .success(function (data, status, headers, config) {
        $scope.getService(service_id, true);
      })
      .error(function (data, status, headers, config) {
        serverService.errorCallback($scope, data, status, headers, config);
      });
  };

  // チュートリアルのマニュアルページを別タブで表示
  $scope.showTutorialPage = function () {
    $window.open($scope.tutorial.manual_link, '_blank');
  };

  // アドバンスド版チュートリアルのマニュアルページを別タブで表示
  $scope.showAdvanceTutorialLink = function (tutorial, step, index) {
    $window.open($scope.system.array_tutorial_advance_step_href[tutorial.type][index], '_blank');
    $scope.completeTutorialStep(step, index, true);
  };

  $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
    if ($scope.tutorial && $scope.tutorial.on) {
      $scope.hideTutorialText();
    }
  });

  $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
    if ($scope.tutorial && $scope.tutorial.on) {
      $timeout(function () {
        $scope.showTutorialText(toState);
      }, 500);
    }
  });

  $scope.$on('completeTutorialStepBloadCast', function (event, args) {
    if (args && $scope.tutorial && $scope.tutorial.on) {
      var arr_args = args.split('.');
      var type = arr_args[0];
      var step_key = arr_args[1];

      if ($scope.tutorial.type == type) {
        angular.forEach($scope.tutorial.steps, function (step, index) {
          if (step_key === step.key) {
            $scope.completeTutorialStep(step, index, false, false);
          }
        });
      }
    }
  });

  $scope.$on('restartTutorialBloadCast', function (event, toState, toParams, fromState, fromParams) {
    var service_id = $scope.my.current_service_id ? $scope.my.current_service_id : $scope.my.service_id;
    $scope.getService(service_id, true).then(function () {
      $scope.setTutorial(true);
    });
  });

  $scope.moveToInquiryFee = function () {
    // 自身の設定を取得
    $scope.getMine(true).then(function () {
      // 権限がなければ、ダッシュボードへ遷移
      $scope.setScopeBillsForCheck().then(function () {
        $scope.hasAuthForInquiryFee();
        if (!$scope.canUseInquiryFee) {
          $scope.noAuthority();
        } else {
          $state.go('inquiry_fee.detail');
        }
      });
    });
  };

  $scope.goToReferenceRoom = function () {
    location.href = getReferenceRoomUrl();
  };

  $scope.getFacilityPlanName = function () {
    return facilityService.getPlanName();
  };

  const getLogoImageFileName = () => {
    if ($scope.isLgwan()) {
      return 'img/codmon_white_logo.svg';
    } else if ($scope.isL4A()) {
      return 'img/codmon_green_logo.svg';
    } else {
      return 'img/codmon_logo_sub.svg';
    }
  };

  $scope.initial();
}

angular.module('inspinia').controller('headerCtrl', headerCtrl);
